import { ImageViewerComponent } from 'src/app/component/image-viewer/image-viewer/image-viewer.component';
import { ApiService } from 'src/app/services/api.service';

import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { PipesModule } from '@root/app/pipes/pipes.module';
import { TripRoute } from '@shared/models';

@Component({
  selector: 'app-route',
  templateUrl: './route.page.html',
  styleUrls: ['./route.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, PipesModule, IonicModule],
})
export class RoutePage implements OnInit {
  route: TripRoute | null = null;
  today: number = new Date().getDay();
  transportec = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalCtrl: ModalController,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    console.log(this.today);
    if (this.activatedRoute.snapshot.data['special']) {
      this.route = this.activatedRoute.snapshot.data['special'];
    }
    this.getRoute();
    if (this.router.url.indexOf('transportec') >= 0) {
      this.transportec = true;
    }
  }

  getRoute() {
    this.apiService.getData('route/' + this.activatedRoute.snapshot.paramMap.get('id')).then((res) => {
      console.log('Getting route: ', res);
      if (res && res.data) {
        this.route = res.data[0];
      }
    });
  }

  getStopDetails(stopId: number) {
    this.apiService.getData('trips/' + stopId).then((res) => {
      console.log('details: ', res);
    });
  }

  async viewImage(src?: string, title: string = '', description: string = '') {
    if (!src) {
      return;
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });
    return await modal.present();
  }
}
